module.exports = __webpack_public_path__ + "media/chateau_de_logne,_outside.9b67a612.wav";